var paramsRegex = /,(?![^(]*(?:\)|}))/g;
var Plugins = /** @class */ (function () {
    function Plugins() {
        this.resetPlugins();
    }
    Plugins.prototype.addCssFunction = function (funcName, func) {
        this.cssFunctions[funcName] = wrapWithValueProvider(func);
        this.updateRegex();
    };
    Plugins.prototype.addDeclarationReplacer = function (func) {
        this.declarationReplacers.push(func);
    };
    Plugins.prototype.resetPlugins = function () {
        this.cssFunctions = {};
        this.declarationReplacers = [];
        this.regex = undefined;
    };
    Plugins.prototype.isSupportedFunction = function (str) {
        return this.regex.test(str);
    };
    Plugins.prototype.getFunctionSignature = function (str) {
        var groups = this.regex.exec(str);
        if (groups) {
            return {
                funcName: groups[1],
                args: groups[2].split(paramsRegex)
            };
        }
        return null;
    };
    Plugins.prototype.updateRegex = function () {
        this.regex = new RegExp("(" + Object.keys(this.cssFunctions).join('|') + ")\\((.*)\\)");
    };
    return Plugins;
}());
export { Plugins };
function wrapWithValueProvider(fnToWrap) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return function (tpaParams) { return fnToWrap.apply(void 0, args.map(function (fn) { return fn(tpaParams); }).concat([tpaParams])); };
    };
}
